export default class SecurityGroup {
  constructor(name, description, permissions, users, appIds){
    this.name = name;
    this.description = description;
    this.permissions = permissions;
    this.users = users;
    this.appIds = appIds;
  }
  name = "";
  description = "";
  permissions = [];
  users = [];
  appIds = [];
}